import React from 'react';
import ReactDOM from 'react-dom';
import './style/index.css';
import App from './components/App';

import { Provider } from 'react-redux';
import store from './stores';

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>, 
	document.getElementById('root')
);